import { Column, ColumnEditorOptions } from "primereact/column"
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dropdown } from 'primereact/dropdown';
import { IClientCompanyDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { FilterPendingInvoiceCompanyWise, InvoiceTrackingFilter, EmptyFilter } from "./FilterPendingInvoiceCompanyWise";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { PaymentTerm } from "../../models/ConsultantMast";
import { BillingCycle } from "./GeneratePO";
import { BillingCycleMap, PaymentTermMap } from "../../models/FDropdown";


interface ITableData {
    invoice_ID?: number,
    company_Name?: string,
    company_Address?: string,
    company_Domain?: string,
    company_Logo?: string,
    vendor_Company_Name?: string,
    invoiceNO?: string,
    prime_Vendor_Payment_Term?: PaymentTerm,
    prime_Vendor_Billing_Cycle?: BillingCycle,
    invoiceDate?: Date | null,
    dueDate?: Date | null,
    consultant_Name?: string,
    invoiceHours?: number,
    sRate?: number,
    invoiceAmount?: number,
    fromDate?: Date,
    toDate?: Date
}

interface IProps {
    //   toast: any
}

export const PendingInvoicesCompanyWise = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITableData>, loading: boolean });
    const [filters, setFilters] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [filter, setFilter] = useState({});
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>([]);
    const [selectedCompany, setSelectedCompany] = useState<ICompanyMastDropdown | null>(null);
    const [selectedRows, setSelectedRows] = useState<ITableData[]>([]);
    const [openGenerateInvModal, setOpenGenerateInvModal] = useState({ open: false, tableData: [] } as { open: boolean, tableData: ITableData[] });
    const [value, setValue] = useState<IClientCompanyDropdown | null>(null);
    const [items, setItems] = useState<IClientCompanyDropdown[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [consultant, setConsultant] = useState<Array<any>>();
    const [value2, setValue2] = useState({ consultant_ID: 0, consultant_Name: "" } as { consultant_ID: number | null, consultant_Name: string | null });
    const [emailSendinSelection, setEmailSendinSelection] = useState({ toSales: false, toRecruiter: false, toSelf: false, moreEmails: "" } as { toSales: boolean, toRecruiter: boolean, toSelf: boolean, moreEmails: string });

    const toast = useRef<any>(null);

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/getInvoiceProceesComapny", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("vwPODetails/pendingInvoicesCompanyWise", "GET", null, `companyID=${selectedCompany?.company_ID}&vendor_Company_ID=${value?.vendor_Company_ID || 0}&consultantName=${value2.consultant_Name}&filter=${JSON.stringify(filter)}`, toast);
        if (response) {
            const data: ITableData[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const loadClientCompanies = async (filter: any) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter.query}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setItems(data.map(item => {
                return { vendor_Company_ID: item.vendor_Company_ID, vendor_Company_Name: item.vendor_Company_Name };
            }));
        }
    }

    const updateRow = async (data: any) => {
        const response = await Fetch("vwPODetails/updateDraftedInvoiceHours", "PUT", null, `invoiceID=${data.invoice_ID}&invoiceHours=${data.invoiceHours}`, toast);
        if (response) {
            toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Follow Up Call History Added Successfully' });
            return true;
        } else {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to Add Follow Up Call History' });
            return false;
        }
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const onCellEditComplete = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'invoiceHours':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };
        if (await updateRow(rowData)) {
            rowData.invoiceAmount = Number(newValue) * rowData.sRate;
            setTableData(prev => {
                const updatedData = prev.tableData.map(item => {
                    if (item.invoice_ID === rowData.invoice_ID) {
                        return {
                            ...item, invoiceHours: isPositiveInteger(rowData.invoiceHours) ? rowData.invoiceHours : item.invoiceHours,
                            invoiceAmount: isPositiveInteger(rowData.invoiceAmount) ? rowData.invoiceAmount : item.invoiceAmount
                        };
                    }
                    return item;
                });
                return { ...prev, tableData: updatedData };
            })
        };
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };
        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', outline: 'none' }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadCompany();
    }, []);

    useEffect(() => {
        // if (selectedCompany !== null && value !== null) {
        //     loadTableData();
        // }
        if (selectedCompany !== null) {
            loadTableData();
        } else (setTableData({ tableData: [], loading: false }));
    }, [selectedCompany, value, filter]);

    const sendNoticeEmail = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetails/sendPendingInvoicesNotice", "POST", null, `companyID=${selectedCompany?.company_ID}&self=${(emailSendinSelection.toSelf === true) ? 1 : 0}&sales=${(emailSendinSelection.toSales === true) ? 1 : 0}&rec=${(emailSendinSelection.toRecruiter === true) ? 1 : 0}&emails=${(emailSendinSelection.moreEmails?.trim() !== "") ? emailSendinSelection.moreEmails?.trim() : ""}`, toast);
        if (response) {
            toast.current.show({ severity: 'success', detail: 'Pending invoices notice sent successfully.', life: 3000 });
            setLoading(false);
            setSelectedRows([]);
            setEmailSendinSelection({ toSales: false, toRecruiter: false, toSelf: false, moreEmails: "" });
            setOpenGenerateInvModal({ open: false, tableData: [] });

            if (selectedCompany?.company_ID !== undefined && selectedCompany?.company_ID !== null && selectedCompany?.company_ID > 0) {
                loadTableData();
            }
        }
        setLoading(false);
    }

    const sendNotice = async () => {
        if (selectedRows.length <= 0) {
            toast.current.show({ severity: 'error', detail: 'Select At Least 1 PV Invoice for sending email.', life: 3000 });
        } else {
            setOpenGenerateInvModal({ open: true, tableData: selectedRows.filter((el: ITableData) => el.invoiceHours !== null && el.invoiceHours !== 0) });
            toast.current.show({ severity: 'success', detail: 'PV Invoice With Working Hours Greater than 0 are selectef for generating invoice and sending email.', life: 3000 });
            // setLoading(true);
            // const response = await Fetch("vwPODetails/sendPendingInvoicesNotice", "POST", null, `companyID=${selectedCompany?.company_ID}`, toast);
            // if (response) {
            //     toast.current.show({ severity: 'success', detail: 'Pending invoices notice sent successfully.', life: 3000 });
            //     if (selectedCompany?.company_ID !== undefined && selectedCompany?.company_ID !== null && selectedCompany?.company_ID > 0) {
            //         loadTableData();
            //     }
            // }
            // setLoading(false);
        }
    }

    const leftToolbarTemplate = () => {
        return <div>
            <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => {
                if (selectedCompany?.company_ID !== undefined && selectedCompany?.company_ID !== null && selectedCompany?.company_ID > 0) {
                    setValue2(prev => prev = { consultant_ID: 0, consultant_Name: "" });
                    setFilters(EmptyFilter);
                    loadTableData();
                }
            }} />
            <Dropdown value={selectedCompany} onChange={(e) => setSelectedCompany(e.value)} options={company} optionLabel="company_Name" editable placeholder="Select a Company" className="w-full md:w-14rem" />
        </div>
    }
    const rightToolbarTemplate = () => {
        return <Button loading={loading} label='Generate & Send Invoices' onClick={sendNotice} />
    }

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        //setValue2(prev => prev = { consultant_ID: 0, consultant_Name: "" });
        loadConsultant(event.query);
    }

    const rightToolbarTemplate2 = () => {
        return <>
            <AutoComplete suggestions={consultant} completeMethod={completeMethodConsultant} field={"consultant_Name"} forceSelection value={value2} placeholder={"Search Consultant"} onChange={(e) => setValue2(e.value)} />
            <Button icon="pi pi-search" className="p-button p-button-info mr-2" onClick={() => {
                if (selectedCompany !== null && value2.consultant_ID !== 0 && value2.consultant_Name !== null && value2.consultant_Name?.trim() !== "") {
                    loadTableData();
                }
            }} />
        </>
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            {/* {selectedCompany !== null && <Toolbar className="mb-1 py-0" right={rightToolbarTemplate2}></Toolbar>} */}
            {selectedCompany !== null && <Accordion>
                <AccordionTab header="Filter">
                    <FilterPendingInvoiceCompanyWise invoiceFilter={filters} setReqFilter={(filters: InvoiceTrackingFilter) => setFilters(filters)} setFilter={(filter: any) => setFilter(filter)} selectedCompany={selectedCompany} />
                </AccordionTab>
            </Accordion>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                dataKey="invoice_ID"
                size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={<p>Pending Invoices</p>}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedRows}
                onSelectionChange={(e) => {
                    const value = e.value as ITableData[];
                    setSelectedRows(value);
                }}
            >
                <Column selectionMode="multiple" />
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Name" />
                <Column field="vendor_Company_Name" header="Client Company" />
                <Column field="prime_Vendor_Billing_Cycle" header="Billing Cycle" body={(r) => BillingCycleMap[r.prime_Vendor_Billing_Cycle]} />
                <Column field="prime_Vendor_Payment_Term" header="Payment Term" body={(r) => PaymentTermMap[r.prime_Vendor_Payment_Term]} />
                {/* <Column field="fromDate" header="From Date" body={(rowData: any) => {
                    let date;
                    if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'MM/dd/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} />
                <Column field="toDate" header="To Date" body={(rowData: any) => {
                    let date;
                    if (rowData.toDate) date = format(new Date(rowData.toDate), 'MM/dd/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} /> */}
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="invoiceHours" header="Hours" body={(rowData) => <p>{rowData.invoiceHours}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="sRate" header="S Rate" />
                <Column field="invoiceAmount" header="Amount" body={(rowData) => <p>{(rowData.invoiceAmount !== null) ? rowData.invoiceAmount : (rowData.invoiceHours * rowData.sRate)}</p>} />
                <Column field="dueDate" header="Due Date" body={(rowData: any) => {
                    let date: Date = new Date();
                    if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Thirty) {
                        date.setDate(date.getDate() + 30);
                    }
                    else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Forty_Five) {
                        date.setDate(date.getDate() + 45);
                    }
                    else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Fifteen) {
                        date.setDate(date.getDate() + 15);
                    }
                    else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Sixty) {
                        date.setDate(date.getDate() + 60);
                    }
                    else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Seven) {
                        date.setDate(date.getDate() + 7);
                    }
                    // return (<p>{format(new Date(date), 'MM/dd/yyyy').toUpperCase()}</p>);
                    return (<p>{safeFormatDate(date?.toString(), "MM/dd/yyyy", DateFormat)}</p>);
                }}
                />
            </DataTable>
            <Dialog visible={openGenerateInvModal.open} style={{ width: '60vw' }} header="Generate PV Invoice & Send Email" modal className="p-fluid" onHide={() => {
                setLoading(false);
                setSelectedRows([]);
                setEmailSendinSelection({ toSales: false, toRecruiter: false, toSelf: false, moreEmails: "" });
                setOpenGenerateInvModal({ open: false, tableData: [] });
            }}>
                <div style={{ width: "50%" }}>
                    Add More Emails In CC :
                </div>
                <div className="w-full p-3" style={{ border: "1px solid #d5d5d5ff" }}>
                    <div className="flex flex-column gap-3 w-full ml-3">
                        <div className="flex flex-wrap gap-5" style={{ width: "70%" }}>
                            <div className="flex align-items-center" style={{ marginLeft: "-1rem" }}>
                                <Checkbox name="pizemailSendinSelectionza" value="Cheese" onChange={() => setEmailSendinSelection({ ...emailSendinSelection, toSelf: !emailSendinSelection.toSelf })} checked={emailSendinSelection.toSelf} />
                                <label htmlFor="toSelf" className="ml-2">To Self</label>
                            </div>
                            <div className="flex align-items-center">
                                <Checkbox name="emailSendinSelection" value="Cheese" onChange={() => setEmailSendinSelection({ ...emailSendinSelection, toRecruiter: !emailSendinSelection.toRecruiter })} checked={emailSendinSelection.toRecruiter} />
                                <label htmlFor="toRecruiter" className="ml-2">To Recruiter</label>
                            </div>
                            <div className="flex align-items-center">
                                <Checkbox name="emailSendinSelection" value="Cheese" onChange={() => setEmailSendinSelection({ ...emailSendinSelection, toSales: !emailSendinSelection.toSales })} checked={emailSendinSelection.toSales} />
                                <label htmlFor="toSales" className="ml-2">To Sales Manager</label>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-content-between mt-2">
                        <div className="flex flex-column" style={{ width: "70%" }}>
                            <label htmlFor="toSales" className="">More Emails <span style={{ color: "#a09f9fff" }}>(Write emails Comma seperated eg: abc@example1.com<span style={{ color: "red", fontWeight: "bolder" }}>,</span> abc@example2.com )</span></label>
                            <InputText value={emailSendinSelection.moreEmails} onChange={(e) => setEmailSendinSelection({ ...emailSendinSelection, moreEmails: e.target.value })} />
                        </div>
                        <Button style={{ width: "15rem", height: "2.5rem", marginTop: "18px" }} loading={loading} label='Generate & Send Invoices' onClick={sendNoticeEmail} />
                    </div>
                </div>
                <div style={{ width: "50%", marginTop: "1rem" }}>
                    Selected Invoices :
                </div>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px", maxHeight: "40vh", overflowY: "scroll" }}
                    dataKey="invoice_ID"
                    size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={openGenerateInvModal.tableData}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="consultant_Name" header="Name" />
                    <Column field="vendor_Company_Name" header="Client Company" />
                    <Column field="prime_Vendor_Billing_Cycle" header="Billing Cycle" body={(r) => BillingCycleMap[r.prime_Vendor_Billing_Cycle]} />
                    <Column field="prime_Vendor_Payment_Term" header="Payment Term" body={(r) => PaymentTermMap[r.prime_Vendor_Payment_Term]} />
                    {/* <Column field="fromDate" header="From Date" body={(rowData: any) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'MM/dd/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />
                    <Column field="toDate" header="To Date" body={(rowData: any) => {
                        let date;
                        if (rowData.toDate) date = format(new Date(rowData.toDate), 'MM/dd/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} /> */}
                    <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                    <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                    <Column field="invoiceHours" header="Hours" body={(rowData) => <p>{rowData.invoiceHours}</p>} />
                    <Column field="sRate" header="S Rate" />
                    <Column field="invoiceAmount" header="Amount" body={(rowData) => <p>{(rowData.invoiceAmount !== null) ? rowData.invoiceAmount : (rowData.invoiceHours * rowData.sRate)}</p>} />
                    <Column field="dueDate" header="Due Date" body={(rowData: any) => {
                        let date: Date = new Date();
                        if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Thirty) {
                            date.setDate(date.getDate() + 30);
                        }
                        else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Forty_Five) {
                            date.setDate(date.getDate() + 45);
                        }
                        else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Fifteen) {
                            date.setDate(date.getDate() + 15);
                        }
                        else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Sixty) {
                            date.setDate(date.getDate() + 60);
                        }
                        else if (rowData.prime_Vendor_Payment_Term === PaymentTerm.Net_Seven) {
                            date.setDate(date.getDate() + 7);
                        }
                        return (<p>{format(new Date(date), 'MM/dd/yyyy').toUpperCase()}</p>);
                    }} />
                </DataTable>
            </Dialog>
            <Toast ref={toast} />
        </>
    );
}